import { Component, EventEmitter, Output, OnInit, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { TextControl } from '@shared/ui/controls/text-control.model';
import { AvailableItemFilter } from '../../../shared/interfaces/select-filters/available-item.filter.interface';
import { faSave } from '@fortawesome/free-solid-svg-icons';
import { AuthenticationService } from '../../../core/services/authentication.serivce';
import { ItemsOnBenchTemplateSelect } from '../../../shared/ui/select-controls/items-on-bench-temp-select.model';
import { ItemsOnBenchTemplateFilter } from '../../../shared/interfaces/select-filters/items-on-bench-temp-filter.interface';
import { ItemsOnOrderSelect } from '../../../shared/ui/select-controls/items-on-order-select.model';
import { ItemsOnOrderFilter } from '../../../shared/interfaces/select-filters/items-on-order-filter.interface';

@Component({
  selector: 'app-remove-items',
  standalone: false,
  templateUrl: './remove-items.component.html',
  styleUrls: ['./remove-items.component.css']
})
export class RemoveItemsComponent implements OnInit {

  @Output() submitForm: EventEmitter<FormGroup> = new EventEmitter();

  public submitted: boolean = false;
  saving: boolean = false;
  saveIcon = faSave;

  id: number;
  public form: FormGroup;

  itemsOnOrder: ItemsOnOrderSelect;

  constructor(private fb: FormBuilder, private auth: AuthenticationService) { }

  ngOnInit() {
    this.itemsOnOrder = new ItemsOnOrderSelect("Test", "", new Array<any>);

    var orderFilters: ItemsOnOrderFilter = {
      OrderId: this.id
    };
    this.itemsOnOrder.filters = orderFilters;

    this.form = this.fb.group({
      id: this.id,
      itemsOnOrder: null,
    });
  }

  save() {
    this.submitted = true;
    this.saving = true;

    var itemsOnOrder = this.itemsOnOrder.value?.map(x => x.id);

    this.form.controls['itemsOnOrder'].setValue(itemsOnOrder);

    this.submitForm.emit(this.form);
  }

}
